var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChevronDown = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 10 6",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M5 3.824 8.498.252A.841.841 0 0 1 9.126 0c.254 0 .463.084.627.252A.879.879 0 0 1 10 .893c0 .26-.082.473-.247.641L5.628 5.748a.785.785 0 0 1-.292.195A.974.974 0 0 1 5 6a.974.974 0 0 1-.336-.057.785.785 0 0 1-.292-.195L.247 1.534A.879.879 0 0 1 0 .894C0 .633.082.42.247.251A.841.841 0 0 1 .874 0c.255 0 .464.084.628.252L5 3.824Z",
  fill: "currentColor"
})));
export default SvgChevronDown;